module.exports = __webpack_public_path__ + "static/Cointiger-2d9aa5b2b44cdcf5378274169adddfb6.png";